import { randomId } from '@shared/utils/randomId.js';

const xMindCloudInstance = randomId();

export default xMindCloudInstance;
